import ColorfulDragbar from './colorful-dragbar';
export default ColorfulDragbar;
